import { render, staticRenderFns } from "./PatientFocus.vue?vue&type=template&id=e2598330&"
import script from "./PatientFocus.vue?vue&type=script&lang=js&"
export * from "./PatientFocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports